import {observer} from 'mobx-react-lite';
import React from 'react';
import {Link} from 'react-router-dom';
import {classy} from 'webapp-lib/utils';

import {
  IconContainer,
  NotificationIndicator,
  StyledNavigationItem,
  TextContainer,
} from './NavigationBarItem.styles';

export type NavigationBarItemProps = React.HTMLAttributes<HTMLAnchorElement> & {
  active?: boolean;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  module: string;
  text: string;
  hasNotification?: boolean;
  modulePath: string;
};

const UNavigationBarItem = ({
  active = false,
  Icon,
  module,
  modulePath,
  text,
  hasNotification,
  ...props
}: NavigationBarItemProps): React.ReactElement => (
  <StyledNavigationItem>
    <Link
      aria-label={text}
      aria-selected={active}
      className={classy({active})}
      data-testid={`nav.${module}`}
      role='tab'
      tabIndex={0}
      title={text}
      to={modulePath}
      {...props}
    >
      <IconContainer>
        {hasNotification ? <NotificationIndicator /> : undefined}
        <Icon />
      </IconContainer>
      <TextContainer>{text}</TextContainer>
    </Link>
  </StyledNavigationItem>
);

export const NavigationBarItem = observer(UNavigationBarItem);
